import { getActas, getActasCsv, getActasNotificadorCsv } from "../services/actas.service";
import {
  controlActaDetalle,
  descargarActasImprimir,
  getActaDetalle,
} from "../services/detalleActa.service";
import { useActaDetalleStore } from "../store/actaDetalleStore";
import { useActasStore } from "../store/actasStore";
import { useGeneralAppStore } from "../store/generalAppStore";
import { crearPDF } from "../views/modals/ModalActaDetalle/ModalImprimirActas2/helpers";

const { handlerModal, modals } = useGeneralAppStore.getState();
const { setAllActaDetalle } = useActaDetalleStore.getState();
const { setActasBuscadas } = useActasStore.getState();

export const getActaDetalleHandler = async (acta, search = false) => {
  const result = await getActaDetalle(acta);
  if (result) {
    setAllActaDetalle(result);
    if (!search && !modals.includes("acta_detalle")) {
      handlerModal({ modal: true, modalName: "acta_detalle" });
    } else {
      setActasBuscadas(result);
    }
  }
};

export const controlShowActaDetalleHandler = async (acta, pathname) => {
  const result = await controlActaDetalle({ id_acta: acta?.id, accion: "show" });
  if (result) {
    if (pathname != "/buscar-acta") {
      const resp = await getActaDetalleHandler(acta);
    }
  }
};

export const controlHideActaDetalleHandler = async (acta) => {
  const result = await controlActaDetalle({ id_acta: acta?.id, accion: "hide" });
};

export const descargarActasImprimirHandler = async (actas, setDownload) => {
  const result = await descargarActasImprimir({ actas_id: actas });
  if (result) {
    crearPDF(result);
    setDownload(true);
  }
};
